import React from 'react';
import './style.css';

const Divider = ({ dividerText }) => {
	if (dividerText)
		return (
			<div className="Divider">
				<div className="line"></div>
				<div className="middle"> {dividerText}</div>
				<div className="line"></div>
			</div>
		);
	return (
		<div className="Divider">
			<div className="line"></div>
		</div>
	);
};

export default Divider;
